import React from 'react';

import './disclaimer.scss';

import { fetchDisclaimer } from 'services/content.service';
import Spinner from 'components/shared/Spinner';
import TopNavSection from 'components/shared/TopNavSection';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRoute } from 'stores/Layout/layoutActions';
import { handleError } from '../../../util';
import ErrorComponent from 'components/shared/ErrorComponent';
import NavigationTabs from 'components/shared/NavigationTabs';

class Disclaimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      loading: true,
    };
  }

  componentDidMount() {
    // fetching disclaimer
    this.props.setRoute({ name: 'Disclaimer', id: this.props.routeId });
    fetchDisclaimer()
      .then((response) => {
        this.setState({
          content: response.data.result.details,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          error: handleError(error),
          loading: false,
        });
      });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="mainWrapper">
          <div className="container">
            <div className="container-wrapper">
              <Spinner />
            </div>
          </div>
        </div>
      );
    }

    if (this.state.error) {
      return (
        <div className="mainWrapper">
          <div className="container">
            <div className="container-wrapper">
              <ErrorComponent />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="mainWrapper">
        <NavigationTabs />
        <div className="static-page-container">
          <div className="privacy-policy-page-content" dangerouslySetInnerHTML={{ __html: this.state.content }} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setRoute }, dispatch);
};
export default connect(null, mapDispatchToProps)(Disclaimer);
